import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { insertNewLine } from '@/utils';
import Section from '../Section';

const Title = styled.div`
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0.7px;
  position: relative;
  text-align: center;
  margin-bottom: 30px;

  &::after {
    background-color: black;
    content: '';
    height: 2px;
    width: 40px;

    position: absolute;
    left: 50%;
    top: 200%;
    transform: translateX(-50%);
  }
`;

const Description = styled.div`
  margin-top: 70px;
  text-align: center;
  white-space: pre-wrap;

  > p {
    font-size: 16px;
  }
`;

const SectionHeader = ({ entryId, title, description }) => (
  <Section id={entryId} options={{ content: { locked: true } }}>
    <Title>{title}</Title>
    {!!(description && description !== '') && (
      <React.Fragment>{insertNewLine({ key: 'section-header', description, component: Description })}</React.Fragment>
    )}
  </Section>
);

SectionHeader.defaultProps = {
  entryId: undefined,
  title: undefined,
  description: undefined,
};

SectionHeader.propTypes = {
  entryId: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
};

export default SectionHeader;



// WEBPACK FOOTER //
// ./src/components/Article/SectionHeader.js